<script lang="ts">
  import { Icon } from '@shared/ui/icon';
  import { cn } from '@shared/utils';

  export let classes = '';
</script>

<div class="{cn('bg-custom-border w-full p-5 text-base', classes)}">
  <div class="mb-3 flex gap-2">
    <Icon name="trident" classes="text-yellow-650" />
    <strong>Defend Ukraine by Preserving its Art</strong>
  </div>
  <div>
    Each artwork purchase contributes to its digital preservation, supports the artist, and efforts to protect Ukraine.
  </div>
</div>

<style lang="scss">
  .bg-custom-border {
    position: relative;

    &::before {
      content: '';
      position: absolute;
      inset: 0;
      border-radius: 8px;
      padding: 2px;
      background: linear-gradient(90deg, #ffa400 0%, #b4f566 46.69%, #6ed6ff 93.38%) border-box;
      mask:
        linear-gradient(#000 0 0) content-box,
        linear-gradient(#000 0 0);
      mask-composite: exclude;
    }
  }
</style>
